import React from 'react'

const OurStory = () => {
  return (
    <div className='story_grid'>
<div className='story_div1'>
        <h2 className='story_head'>Our Story</h2>
  
</div>
<div className='story_div2'>
<div className='story2'>
    <p className='story_content'>Founded on a vision to disrupt the digital marketing scene, Zweedo was built by marketers who understand that every business deserves a tailored approach—not a one-size-fits-all solution.<br/>
Starting as a small, agile team, we have already partnered with startups and growing businesses, delivering impactful SEO, PPC, social media, and content marketing solutions. Our startup roots make us nimble and adaptive—qualities essential in the constantly evolving digital world.
</p>
</div>
</div>
    </div>
  )
}

export default OurStory